import React from 'react';
import styled from 'styled-components';
import {
    Nav,
    IconProps,
    SpotifyFilled,
    YoutubeFilled,
    FacebookFilled,
    TwitterFilled,
    InstagramFilled,
    TiktokOutlined,
    spacing,
} from '@landr/maestro';

interface IconLinkProps {
    icon: React.FC<IconProps>;
    href: string;
    label: string;
}

const StyledNavLink = styled(Nav.Link)`
    ${({ theme }): string => theme.breakpoint('md')`
        padding: ${spacing('xs')};
    `}
`;

const StyledNavItem = styled(Nav.Item)`
    :first-child {
        & ${StyledNavLink} {
            ${({ theme }): string => theme.breakpoint('md')`
                padding-left: 0;
            `}
        }
    }
`;

const IconLink: React.FC<IconLinkProps> = ({ href, label, icon: Icon }) => {
    return (
        <StyledNavItem>
            <StyledNavLink href={href} target="_blank" aria-label={label}>
                <Icon size="md" title={label} />
            </StyledNavLink>
        </StyledNavItem>
    );
};

const iconLinkList: Array<IconLinkProps> = [
    {
        href: 'https://open.spotify.com/playlist/6R6NG6OhuXubiRCztBrLac',
        label: 'Spotify',
        icon: SpotifyFilled,
    },
    {
        href: 'https://www.youtube.com/LANDRmusic',
        label: 'Youtube',
        icon: YoutubeFilled,
    },
    {
        href: 'https://www.facebook.com/LANDRmusic',
        label: 'Facebook',
        icon: FacebookFilled,
    },
    {
        href: 'https://twitter.com/landr_music',
        label: 'Twitter',
        icon: TwitterFilled,
    },
    {
        href: 'https://www.instagram.com/landrmusic',
        label: 'Instagram',
        icon: InstagramFilled,
    },
    {
        href: 'https://www.tiktok.com/@landrmusic',
        label: 'Tiktok',
        icon: TiktokOutlined,
    },
];

export const SocialNavigation: React.FC = () => {
    return (
        <Nav sx={{ flex: '0 1 auto', width: 'auto' }}>
            {iconLinkList.map((props) => (
                <IconLink key={props.label} {...props} />
            ))}
        </Nav>
    );
};
